module.exports = __webpack_public_path__ + "img/arrow-right-orange.f6ca898d.svg";